module.exports = __webpack_public_path__ + "static/images/callout_3.a5eab73bb23c63c11434929db898dc7f.jpg";